import useGetUserInfo from './hooks/useGetUserInfo'
import Header from 'components/headers/bulletins'
import DotsLoading from 'components/loadings/dotsLoading'
import UserInfo from 'modules/financialHistory/userInfo'
import CustomTabs from 'modules/financialHistory/tabs'

export default function FinancialHistory() {
    const { userInfo, isLoadingUserInfo } = useGetUserInfo()
    return (
        <div>
            <Header title="سابقه مالی عضو" />
            {isLoadingUserInfo ? (
                <DotsLoading />
            ) : (
                userInfo && <UserInfo data={userInfo} />
            )}
            <CustomTabs />
        </div>
    )
}
